import { DocumentTypeHandler } from "@/dbot/common/commonDomain";
import { applyForm, SubscriptionForm, SubscriptionFormForm } from "./subscriptionFormDomain";
import { DocumentType } from "@/common/documents";

export const subscriptionFormHandler: DocumentTypeHandler<
  DocumentType.subscription_form,
  SubscriptionForm,
  SubscriptionFormForm
> = {
  type: DocumentType.subscription_form,
  initNewForm: (dispatch, context) => new SubscriptionFormForm(dispatch, context),
  initForm: (form) => form.init(),
  applyForm: (form) => applyForm(form),
};
